// import { filter } from "lodash";
import { sentenceCase } from "change-case";
import { useState, forwardRef, useEffect, useRef } from "react";
import { Icon } from "@iconify/react";
import searchFill from "@iconify/icons-eva/search-fill";
import pinFill from "@iconify/icons-eva/pin-fill";
import { useNavigate, useLocation, useSearchParams } from "react-router-dom";
import CheckIcon from "@mui/icons-material/Check";
import AccountTreeRoundedIcon from "@mui/icons-material/AccountTreeRounded";
import DoNotDisturbAltIcon from "@mui/icons-material/DoNotDisturbAlt";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import roundAccountTree from "@iconify/icons-ic/round-account-tree";
import { Portal } from "@mui/base";
// import * as Yup from "yup";
// material
import {
  Card,
  Table,
  Stack,
  // Avatar,
  Button,
  TextField,
  TableRow,
  TableBody,
  TableCell,
  Container,
  Typography,
  TableContainer,
  TablePagination,
  Divider,
  Box,
  Chip,
  FormControl,
  InputLabel,
  Select,
  FormHelperText,
  MenuItem,
  OutlinedInput,
  Link,
} from "@mui/material";
// components
import Page from "../components/Page";
import Label from "../components/Label";
import Scrollbar from "../components/Scrollbar";
import CloseIcon from "@mui/icons-material/Close";
import {
  LocationListHead,
  LocationListToolbar,
  LocationMoreMenu,
} from "../components/_dashboard/location";
import { filter } from "lodash";
import { sort } from "fast-sort";
//
// import LOCATIONLIST from "../_mocks_/location";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import Slide from "@mui/material/Slide";
import Pagination from "@mui/material/Pagination";
import LinearProgress from "@mui/material/LinearProgress";
import Snackbar from "@mui/material/Snackbar";
import MuiAlert from "@mui/material/Alert";
import menu from "@iconify/icons-ic/baseline-menu";
import { CallApi } from "../statics.js";
import DatePicker, { DateObject } from "react-multi-date-picker";
import persian_calendar from "react-date-object/calendars/persian";
import persian_language from "react-date-object/locales/persian_fa";
import persian_language_en from "react-date-object/locales/persian_en";
import gregorian from "react-date-object/calendars/gregorian";
import gregorian_en from "react-date-object/locales/gregorian_en";
import weekends from "react-multi-date-picker/plugins/highlight_weekends";
import "react-multi-date-picker/styles/layouts/prime.css";
import "react-multi-date-picker/styles/layouts/mobile.css";
import "react-multi-date-picker/styles/colors/green.css";
// import InputIcon from "react-multi-date-picker/components/input_icon";

const weekDays = ["ش", "ی", "د", "س", "چ", "پ", "ج"];

const Alert = forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

const Transition = forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

function SlideTransition(props) {
  return <Slide {...props} direction="left" />;
}
// ----------------------------------------------------------------------
function applySortFilter(array, order, orderBy, query) {
  let list = array;
  let result = [];
  if (order === "asc") {
    result = sort(list).by([
      {
        asc: (u) => {
          if (typeof u[orderBy] === "string" || u[orderBy] instanceof String)
            return u[orderBy].toLowerCase();
          else return u[orderBy];
        },
      },
      { asc: (u) => u.createdAt },
    ]);
  } else {
    result = sort(list).by([
      {
        desc: (u) => {
          if (typeof u[orderBy] === "string" || u[orderBy] instanceof String)
            return u[orderBy].toLowerCase();
          else return u[orderBy];
        },
      },
      { desc: (u) => u.createdAt },
    ]);
  }

  if (query) {
    return filter(
      result,
      (_user) => _user.title.toLowerCase().indexOf(query.toLowerCase()) !== -1
    );
  }

  return result;
}

const TABLE_HEAD = [
  { id: "id", label: "Order Id", alignRight: false },
  { id: "fullName", label: "Customer", alignRight: false },
  { id: "mobile", label: "Mobile", alignRight: false },
  { id: "totalMeterage", label: "Area (m²)", alignRight: false },
  { id: "finalPrice", label: "Final Price (IRR)", alignRight: false },
  { id: "createdAt", label: "Date & Time", alignRight: false },
  { id: "detail", label: "Details", alignRight: false },
];

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

export default function ReceivedOrders() {
  const [page, setPage] = useState(0);
  const [totalItems, setTotalItems] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [open, setOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackType, setSnackType] = useState(false);
  const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);
  const [buttonDisabled, setButtonDisabled] = useState(false);
  const [infoDialogOpen, setInfoDialogOpen] = useState(false);
  const [currentLocItem, setCurrentLocItem] = useState({ title: "" });
  const [actionMode, setActionMode] = useState("accepting");
  const [dialogMode, setDialogMode] = useState("add");
  const [searchValue, setSearchValue] = useState("");
  const [submittedSearchValue, setSubmittedSearchValue] = useState("");
  const [modelDes, setModelDes] = useState("");
  const [modelDesErrorText, setModelDesErrorText] = useState("");

  const [minHeight, setMinHeight] = useState("");
  const [minHeightErrorText, setMinHeightErrorText] = useState("");
  const [maxHeight, setMaxHeight] = useState("");
  const [maxHeightErrorText, setMaxHeightErrorText] = useState("");
  const [minWidth, setMinWidth] = useState("");
  const [minWidthErrorText, setMinWidthErrorText] = useState("");
  const [maxWidth, setMaxWidth] = useState("");
  const [maxWidthErrorText, setMaxWidthErrorText] = useState("");
  const [obsoletedValue, setObsoletedValue] = useState("");
  const [obsoletedValueErrorText, setObsoletedValueErrorText] = useState("");
  // const [addModelLoading, setAddModelLoading] = useState(false);
  const [addDialogOpen, setAddDialogOpen] = useState(false);

  const [order, setOrder] = useState("desc");
  const [orderBy, setOrderBy] = useState("createdAt");
  const [filterName, setFilterName] = useState("");

  const [startDateValue, setStartDateValue] = useState(null);
  const [endDateValue, setEndDateValue] = useState(null);
  const [totalMinDate, setTotalMinDate] = useState(null);
  const [totalMaxDate, setTotalMaxDate] = useState(null);

  const [submittedFilterDateValue, setSubmittedFilterDateValue] = useState("");

  // const [submittedStartDateValue, setSubmittedStartDateValue] = useState("");
  // const [submittedEndDateValue, setSubmittedEndDateValue] = useState("");

  const [dataLoading, setDataLoading] = useState(true);
  const [tableData, setTableData] = useState([]);
  const [productValue, setProductValue] = useState("");
  const [productValueErrorText, setProductValueErrorText] = useState("");
  const [productList, setProductList] = useState([]);
  const [currentModelItem, setCurrentModelItem] = useState({
    id: "",
    title: "",
  });

  const [searchParams, setSearchParams] = useSearchParams();

  const navigate = useNavigate();

  function getCookie(cname) {
    let name = cname + "=";
    let ca = document.cookie.split(";");
    for (let i = 0; i < ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) === " ") {
        c = c.substring(1);
      }
      if (c.indexOf(name) === 0) {
        return c.substring(name.length, c.length);
      }
    }
    return "";
  }

  useEffect(() => {
    let data = {
      username: getCookie("username"),
      token: getCookie("token"),
      page: page,
      count: rowsPerPage,
      searchKey: "",
      fromDate: "",
      toDate: "",
    };
    getOrderList(data);
  }, []);

  const getOrderList = (data) => {
    console.log(data);
    setDataLoading(true);
    CallApi("getOrderList", "post", data).then((result) => {
      try {
        setDataLoading(false);
        if (result.status === 200) {
          console.log(result);
          setTableData(result.orderList);
          setTotalItems(result.paginateInfo.totalItems);

          const min = new DateObject({
            date: result.MINDATE,
            format: "YYYY/MM/DD",
            calendar: persian_calendar,
            locale: persian_language_en,
          });
          const max = new DateObject({
            date: result.MAXDATE,
            format: "YYYY/MM/DD",
            calendar: persian_calendar,
            locale: persian_language_en,
          });

          setTotalMinDate(min);
          setTotalMaxDate(max);
          if (!startDateValue) setStartDateValue(min);
          if (!endDateValue) setEndDateValue(max);
        }
      } catch (error) {
        console.log("error: ", error);
      }
    });
  };

  const handleChangePage = (e, value) => {
    setPage(value);
  };

  useEffect(() => {
    let dates = submittedFilterDateValue
      ? submittedFilterDateValue.split("&&")
      : ["", ""];
    let data = {
      username: getCookie("username"),
      token: getCookie("token"),
      page: page,
      count: rowsPerPage,
      searchKey: submittedSearchValue,
      fromDate: dates[0],
      toDate: dates[1],
    };

    if (tableData.length > 0) getOrderList(data);
  }, [page]);

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
  };

  const formatter = (value) => {
    return `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  };

  const filteredDataList = applySortFilter(
    tableData,
    order,
    orderBy,
    filterName
  );

  const isUserNotFound = filteredDataList.length === 0;

  function CustomInput({ onFocus, value, onChange, placeholder, label }) {
    return (
      <TextField
        sx={{ width: "120px" }}
        size="small"
        label={label}
        onFocus={onFocus}
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        InputProps={{
          className: "custom-input",
        }}
      />
    );
  }

  const onConfirmFilter = () => {
    let date = "";
    let date1 = "";
    console.log(new DateObject(startDateValue));
    if (startDateValue) {
      date = new DateObject(startDateValue)
        .convert(persian_calendar, persian_language_en)
        .format("YYYY-MM-DD");
    }
    if (endDateValue) {
      date1 = new DateObject(endDateValue)
        .convert(persian_calendar, persian_language_en)
        .format("YYYY-MM-DD");
    }
    // const date1 = new DateObject({
    //   date: endDateValue,
    //   format: "YYYY/MM/DD",
    //   calendar: persian_calendar,
    //   locale: persian_language_en,
    // });
    // console.log(date);
    // console.log(date1);
    // return;
    setSubmittedFilterDateValue(date + "&&" + date1);
    // setSubmittedEndDateValue(endDateValue);
  };

  const onConfirmSearch = () => {
    setSubmittedSearchValue(searchValue);
  };

  useEffect(() => {
    if (submittedSearchValue || submittedFilterDateValue) {
      let dates = submittedFilterDateValue
        ? submittedFilterDateValue.split("&&")
        : ["", ""];
      let data = {
        username: getCookie("username"),
        token: getCookie("token"),
        page: page,
        count: rowsPerPage,
        searchKey: submittedSearchValue,
        fromDate: dates[0],
        toDate: dates[1],
      };
      getOrderList(data);
    }
  }, [submittedSearchValue, submittedFilterDateValue]);

  return (
    <Page title="Received Orders | Admin Panel">
      {dataLoading && (
        <LinearProgress
          color="primary"
          sx={{
            ml: -2,
            zIndex: "100000",
            width: "100%",
            position: "fixed",
            top: "0px",
          }}
        />
      )}
      {!dataLoading && (
        <Container sx={{ position: "relative" }}>
          <Stack
            direction="row"
            alignItems="center"
            justifyContent="space-between"
            mb={5}
          >
            <Typography variant="h4" gutterBottom>
              Received Orders
            </Typography>
            {/* <Button
              onClick={handleClickOpen}
              variant="contained"
              // component={RouterLink}
              // to="new"
              // state={{ type: "new" }}
              disabled={buttonDisabled}
              startIcon={<Icon icon={plusFill} />}
            >
              New Model
            </Button> */}
          </Stack>

          <Card>
            <div className="ordersFilterContainer">
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  gap: "5px",
                  alignItems: "center",
                  // margin: "10px",
                }}
              >
                <TextField
                  // fullWidth
                  sx={{ width: "230px" }}
                  size="small"
                  autoFocus
                  type="text"
                  label="Search"
                  value={searchValue}
                  onChange={(e) => setSearchValue(e.target.value)}
                  placeholder="order id, customer or mobile"
                  // disabled={buttonDisabled}
                />
                <Button
                  onClick={onConfirmSearch}
                  variant="contained"
                  // disabled={buttonDisabled}
                  startIcon={<Icon icon={searchFill} />}
                >
                  Search
                </Button>
              </div>

              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  gap: "5px",
                  alignItems: "center",
                  // margin: "10px",
                  fontFamily: "SFUIDisplay",
                }}
              >
                <DatePicker
                  render={<CustomInput placeholder="start date" label="from" />}
                  calendar={persian_calendar}
                  locale={persian_language}
                  minDate={totalMinDate}
                  // maxDate={new Date()}
                  maxDate={totalMaxDate}
                  weekDays={weekDays}
                  shadow={false}
                  value={startDateValue}
                  highlightToday={false}
                  onChange={(e) => {
                    console.log(e);
                    setStartDateValue(e);
                  }}
                  className="rmdp-mobile"
                  mobileButtons={[
                    {
                      label: "پاک کردن",
                      type: "button",
                      className: "rmdp-button rmdp-action-button",
                      onClick: () => setStartDateValue({}),
                    },
                  ]}
                />

                <DatePicker
                  render={<CustomInput placeholder="end date" label="to" />}
                  calendar={persian_calendar}
                  locale={persian_language}
                  minDate={
                    startDateValue ? new DateObject(startDateValue) : null
                  }
                  maxDate={totalMaxDate}
                  // maxDate={new Date()}
                  weekDays={weekDays}
                  shadow={false}
                  value={endDateValue}
                  onChange={(e) => {
                    setEndDateValue(e);
                  }}
                  className="rmdp-mobile"
                  mobileButtons={[
                    {
                      label: "پاک کردن",
                      type: "button",
                      className: "rmdp-button rmdp-action-button",
                      onClick: () => setEndDateValue({}),
                    },
                  ]}
                />

                <Button
                  onClick={onConfirmFilter}
                  variant="contained"
                  // disabled={buttonDisabled}
                  // startIcon={<Icon icon={searchFill} />}
                >
                  Filter
                </Button>
              </div>
            </div>
            <Scrollbar>
              <TableContainer sx={{ minWidth: 800 }}>
                <Table>
                  <LocationListHead
                    headLabel={TABLE_HEAD}
                    rowCount={filteredDataList.length}
                    order={order}
                    orderBy={orderBy}
                    onRequestSort={handleRequestSort}
                  />
                  {!isUserNotFound && (
                    <TableBody>
                      {filteredDataList.map((row) => {
                        // { id: "id", label: "Order Id", alignRight: false },
                        // { id: "fullName", label: "Customer", alignRight: false },
                        // { id: "mobile", label: "Mobile", alignRight: false },
                        // { id: "totalMeterage", label: "Total Meterage", alignRight: false },
                        // { id: "totalPrice", label: "Total Price", alignRight: false },
                        // { id: "createdAt", label: "Date & Time", alignRight: false },
                        //   const { _id, title, descr, lineTitle } = row;
                        return (
                          <TableRow hover key={row.id} tabIndex={-1}>
                            <TableCell>{row.id}</TableCell>
                            <TableCell>
                              {row.fullName ? row.fullName : "-"}
                            </TableCell>
                            <TableCell>{row.mobile}</TableCell>
                            <TableCell>
                              {row.totalMeterage
                                ? formatter(row.totalMeterage)
                                : "-"}
                            </TableCell>
                            <TableCell>
                              {row.finalPrice ? formatter(row.finalPrice) : "-"}
                            </TableCell>
                            <TableCell>
                              {row.createdAt.replace(" ", " - ")}
                            </TableCell>
                            <TableCell align="left">
                              <Link href={"/receivedorders/" + row.id}>
                                <Box
                                  component={Icon}
                                  icon={menu}
                                  sx={{
                                    color: "primary.main",
                                    width: 24,
                                    height: 24,
                                    cursor: "pointer",
                                  }}
                                />
                              </Link>
                            </TableCell>
                          </TableRow>
                        );
                      })}
                    </TableBody>
                  )}
                  {isUserNotFound && (
                    <TableBody>
                      <TableRow>
                        <TableCell
                          align="center"
                          colSpan={12}
                          sx={{
                            py: 3,
                            color: "text.disabled",
                            fontSize: "12px",
                          }}
                        >
                          No Data
                        </TableCell>
                      </TableRow>
                    </TableBody>
                  )}
                </Table>
              </TableContainer>
            </Scrollbar>
            <TablePagination
              rowsPerPageOptions={[]}
              component="div"
              count={totalItems}
              rowsPerPage={rowsPerPage}
              page={page}
              onPageChange={handleChangePage}
            />
          </Card>
        </Container>
      )}

      <Portal>
        <Snackbar
          open={snackbarOpen}
          onClose={() => setSnackbarOpen(false)}
          TransitionComponent={SlideTransition}
          autoHideDuration={6000}
          anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        >
          <Alert
            onClose={() => setSnackbarOpen(false)}
            severity={snackType}
            sx={{ width: "100%" }}
          >
            {snackbarMessage}
          </Alert>
        </Snackbar>
      </Portal>
    </Page>
  );
}
